// @ts-strict-ignore
import { Pipe, PipeTransform } from '@angular/core';
import { LMFormatUtilService } from '../services/utils/index';

@Pipe({
  name: 'stateAsText'
})
export class LMStateAsTextPipe implements PipeTransform {

  constructor(private lmFormatUtilService: LMFormatUtilService) { }

  transform(modelFieldValue, states: Array<LMStateValue>, displayAsTag = false): string {
    const value = this.lmFormatUtilService.stateLabelToText(states, modelFieldValue);

    // if display as tag, then empty values must be returned as an empty string so the :empty pseudo element works correctly
    if (displayAsTag) {
      // tslint:disable-next-line:triple-equals > using non-strict equality to evaluate 0, '0', 0.00, '0.00' as zero, etc
      if (value === ' ' || value == '0') {
        return '';
      }
    }

    return value;
  }
}
